export default __webpack_public_path__ + "static/media/ActivityIcon2.77824aab.svg";